import axios from 'axios';
import { cookies } from 'src/helpers/Session';

interface userAuth {
	username: string;
	password: string;
}

const { REACT_APP_API_URL } = process.env;

class AuthService {
	async login(credentials: userAuth) {
		const response = await axios.post(
			`${REACT_APP_API_URL}/users/auth`,
			credentials,
		);
		return response.data;
	}

	async me() {
		const response = await axios.get(`${REACT_APP_API_URL}/users/me`, {
			headers: { Authorization: `Bearer ${cookies.get('auth')}` },
		});
		return response.data;
	}

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	async forgotPassword(payload: any) {
		const response = await axios.post(
			`${REACT_APP_API_URL}/backoffice/users/forgot_password`,
			payload,
		);
		return response;
	}

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	async resetPassword(payload: any) {
		const response = await axios.post(
			`${REACT_APP_API_URL}/backoffice/users/update_password`,
			payload,
		);
		return response;
	}
}

export default AuthService;
